import { SearchStatus, amountParts } from '../../constants';
import { getAgentTipsSuccess } from '../slices/intelligence';

const tips = {};

const onTipsNotificationReceived = (store) => (res) => {
  console.log('****** NOTIFICATION ******', res);

  tips[`${res.cruiseItineraryId}-${res.flightOriginGeoIndex}`] = {
    ...tips[`${res.cruiseItineraryId}-${res.flightOriginGeoIndex}`],
    cruiseItineraryId: res.cruiseItineraryId,
    flightOriginGeoIndex: res.flightOriginGeoIndex,
    [res.message]: res.data,
  };

  Object.values(tips).forEach(({ cruiseItineraryId, flightOriginGeoIndex, ...tipData }) => {
    if (cruiseItineraryId === res.cruiseItineraryId
            && flightOriginGeoIndex === res.flightOriginGeoIndex
    ) {
      if (Object.values(tipData).flat().length > 0 || Object.keys(tipData).length === 4) {
        store.dispatch(getAgentTipsSuccess({
          cruiseItineraryId,
          flightOriginGeoIndex,
          status: Object.keys(tipData).length === amountParts.initial
            ? SearchStatus.DONE
            : SearchStatus.SEARCHING,
          tips: Object.values(tipData).flat(),
        }));
      }
    }
  });
};

export default onTipsNotificationReceived;
